{ Analytics } = require '@trello/atlassian-analytics'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
CardView = require 'app/scripts/views/card/card-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
View = require 'app/scripts/views/internal/view'
t = require 'teacup'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'
{ track } = require '@trello/analytics'

renderBoardName = t.renderable (boardName, iconClass) ->
  t.strong ->
    t.text boardName
  t.span '.icon-sm', { class: "icon-#{iconClass}" }

renderListName = t.renderable (listName) ->
  t.strong ->
    t.text listName


module.exports = class CardSearchResultView extends View
  className: 'search-result-card'

  events:
    'click .list-card': 'openCard'

  render: ->
    board = @model.getBoard()
    list = @model.getList()
    data = _.extend @model.toJSON(),
      listName: renderListName(list.get('name')),
      boardName: renderBoardName(board.get('name'), BoardDisplayHelpers.getPermLevelIconClassForBoard(board))

    cardViewOpts =
      hideMenu: true
      applyBoardCardFilter: false

    @$el.html(
      templates.fill(
        'search_results_card',
        data
      )
    )

    cardView = @subview(CardView, @model, cardViewOpts)
    @appendSubview(cardView, @$('.js-list-card-container'))
    @

  openCard: (e) ->
    @model.showDetail()
    track("Search", "Select Card")
    if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
      Analytics.sendUIEvent
        action: 'clicked'
        actionSubject: 'card'
        actionSubjectId: 'searchResultCard'
        source: 'searchResultsScreen'
    return
